/** @file asPose3DError: any thrown value as a Pose3DError (non-coded errors become TRANSPORT). */
import { ERROR_CODES } from '@zilo/pose3d-format/errors/codes';
import type { Pose3DError } from '@zilo/pose3d-std/errors/pose3DError';
import { toPose3DError } from '@zilo/pose3d-std/errors/toPose3DError';

/** The value itself when it is a Pose3DError, else a `TRANSPORT` error carrying its message. */
export function asPose3DError(e: unknown): Pose3DError {
  return toPose3DError(e)
    ?? { name: 'Pose3DError', code: ERROR_CODES.TRANSPORT, params: {}, message: e instanceof Error ? e.message : String(e) };
}
